var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",class:{
    userPopout:true,
    _visible:_vm.visible,
    fixed:_vm.fixed,
    relative:_vm.relative,
    fillHorizontal:_vm.fillHorizontal
},style:(_vm.coords?{
    left: ((_vm.useCoords.x) + "px"),
    top: ((_vm.useCoords.y) + "px")     
}:null)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }